import { useCallback, useEffect } from 'react';

type Direction = 'left' | 'right';

type PressedKeys = {
  left?: boolean;
  right?: boolean;
};

let pressedKeys: PressedKeys = {};

export function useKeyEvents() {
  useEffect(() => {
    function updateKeys(event: KeyboardEvent, active: boolean) {
      switch (event.code) {
        case 'ArrowLeft':
          pressedKeys['left'] = active;
          break;
        case 'ArrowRight':
          pressedKeys['right'] = active;
          break;
      }
    }

    function handleKeyUp(event: KeyboardEvent) {
      updateKeys(event, false);
    }
    function handleKeyDown(event: KeyboardEvent) {
      updateKeys(event, true);
    }

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      pressedKeys = {};
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  const isKeyPressed = useCallback((direction: Direction) => {
    return pressedKeys[direction];
  }, []);

  return isKeyPressed;
}
